import React, { useState, useRef, useEffect, useMemo } from "react";
import { Form } from 'react-bootstrap';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import { GenericModal } from '../../../../components/common/Modal/GenericModal';
import { showErrorToast } from '../../../../components/PluginsMenu/Toastr/Toastr';
import user from "../../../../../images/no_user_placeholder.png";
import { genderOptions } from "../../../../../dummy";
import { TutorValidationSchema } from '../../../../../validations';
import Select from 'react-select';
import LanguageSelect from "../../../student/profile/personal-details/LanguageSelect";
import CountryCodeSelect from "../../../../components/common/CountryCodeSelect";

export const CreateTutorModal = ({ show, handleClose, handleSave, learningLanguages, languages }) => {
  const [profilePicture, setProfilePicture] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef();
  const formikRef = useRef();

  // Updated timezone options
  const timezoneOptions = useMemo(() => [
    { value: 'UTC−10  Pacific/Honolulu', label: 'UTC−10  Pacific/Honolulu' },
    { value: 'UTC−09  America/Anchorage', label: 'UTC−09  America/Anchorage' },
    { value: 'UTC−08  America/Los_Angeles', label: 'UTC−08  America/Los_Angeles' },
    { value: 'UTC−07  America/Denver', label: 'UTC−07  America/Denver' },
    { value: 'UTC−06  America/Chicago', label: 'UTC−06  America/Chicago' },
    { value: 'UTC−05  America/New_York', label: 'UTC−05  America/New_York' },
    { value: 'UTC−04  America/Barbados', label: 'UTC−04  America/Barbados' },
    { value: 'UTC−03  America/Sao_Paulo', label: 'UTC−03  America/Sao_Paulo' },
    { value: 'UTC−02  Atlantic/South_Georgia', label: 'UTC−02  Atlantic/South_Georgia' },
    { value: 'UTC−01  Atlantic/Azores', label: 'UTC−01  Atlantic/Azores' },
    { value: 'UTC±00  Europe/London', label: 'UTC±00  Europe/London' },
    { value: 'UTC+01  Africa/Lagos', label: 'UTC+01  Africa/Lagos' },
    { value: 'UTC+02  Africa/Cairo', label: 'UTC+02  Africa/Cairo' },
    { value: 'UTC+03  Africa/Nairobi', label: 'UTC+03  Africa/Nairobi' },
    { value: 'UTC+03:30  Asia/Tehran', label: 'UTC+03:30  Asia/Tehran' },
    { value: 'UTC+04  Asia/Dubai', label: 'UTC+04  Asia/Dubai' },
    { value: 'UTC+04:30  Asia/Kabul', label: 'UTC+04:30  Asia/Kabul' },
    { value: 'UTC+05  Asia/Karachi', label: 'UTC+05  Asia/Karachi' },
    { value: 'UTC+05:30  Asia/Kolkata', label: 'UTC+05:30  Asia/Kolkata' },
    { value: 'UTC+05:45  Asia/Kathmandu', label: 'UTC+05:45  Asia/Kathmandu' },
    { value: 'UTC+06  Asia/Dhaka', label: 'UTC+06  Asia/Dhaka' },
    { value: 'UTC+06:30  Asia/Yangon', label: 'UTC+06:30  Asia/Yangon' },
    { value: 'UTC+07  Asia/Bangkok', label: 'UTC+07  Asia/Bangkok' },
    { value: 'UTC+08  Asia/Shanghai', label: 'UTC+08  Asia/Shanghai' },
    { value: 'UTC+09  Asia/Tokyo', label: 'UTC+09  Asia/Tokyo' },
    { value: 'UTC+09:30  Australia/Darwin', label: 'UTC+09:30  Australia/Darwin' },
    { value: 'UTC+10  Australia/Sydney', label: 'UTC+10  Australia/Sydney' },
    { value: 'UTC+11  Pacific/Guadalcanal', label: 'UTC+11  Pacific/Guadalcanal' },
    { value: 'UTC+12  Pacific/Auckland', label: 'UTC+12  Pacific/Auckland' },
    { value: 'UTC+13  Pacific/Tongatapu', label: 'UTC+13  Pacific/Tongatapu' },
    { value: 'UTC+14  Pacific/Kiritimati', label: 'UTC+14  Pacific/Kiritimati' }
  ], []);

  useEffect(() => {
    if (!show) {
      setProfilePicture(null);
      setPreviewUrl(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  }, [show]);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setProfilePicture(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const whatsappNumber = values.whatsappNumber;

      await handleSave({ ...values, ProfilePicture: profilePicture, whatsappNumber: whatsappNumber });
      formikRef.current.resetForm();
      setProfilePicture(null);
      setPreviewUrl(null);
      handleClose(); 
    } catch (err) {
      showErrorToast(err.message || 'Save failed');
    } finally {
      setSubmitting(false);
    }
  };
  console.log(languages);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        Name: '',
        Gender: '',
        Email: '',
        Location: '',
        Dialect: '',
        Age: '',
        Education: '',
        Language: '',
        Timezone: '',
        ExperienceLevel: '',
        About: '',
        whatsappNumber: ''
      }}
      validationSchema={TutorValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, isSubmitting, values, setFieldValue }) => (
        <GenericModal
          show={show}
          handleClose={handleClose}
          title="Create Tutor Profile"
          handleSave={() => formikRef.current.submitForm()}
        >
          <FormikForm onSubmit={handleSubmit}>
            <div className="text-center mb-4">
              <div className="author-profile text-center">
                <div
                  className="position-relative d-inline-block"
                  style={{ width: "130px", height: "130px" }}
                >
                  <img
                    src={previewUrl || user}
                    alt="user-image"
                    className="rounded-circle border"
                    height="130"
                    width="130"
                    style={{ objectFit: "cover" }}
                  />
                  {/* Upload Button Overlay */}
                  <div
                    className="position-absolute d-flex justify-content-center align-items-center bg-dark"
                    style={{
                      bottom: "6px",
                      right: "6px",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      cursor: "pointer",
                      opacity: 0.8,
                    }}
                    onClick={() => fileInputRef.current?.click()}
                    title="Update Profile Picture"
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleImageChange}
                      accept="image/*"
                      style={{ display: "none" }}
                    />
                    <i className="fa fa-camera text-white" style={{ fontSize: "14px" }} />
                  </div>
                </div>
              </div>
            </div>

            <Form className="row">
              {[
                ["Name", "text", "Enter tutor name"],
                ["Email", "email", "Enter tutor email"],
                ["Location", "text", "Enter location"],
              ].map(([name, type, placeholder]) => (
                <div className="col-md-6 mb-3" key={name}>
                  <Form.Label>{name}</Form.Label>
                  <Field
                    as={Form.Control}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                  />
                  <div className="text-danger">
                    <ErrorMessage name={name} />
                  </div>
                </div>
              ))}

              <div className="col-md-6 mb-3">
                <Form.Label>Also Speaks</Form.Label>
                 <Field name="Dialect"
                  component={LanguageSelect}
                  options={languages}
                  placeholder="Select language" />  
                <div className="text-danger"><ErrorMessage name="Dialect" /></div>
              </div>

              {[
                ["Age", "number", "Enter age"],
                ["Education", "text", "Enter education"],
              ].map(([name, type, placeholder]) => (
                <div className="col-md-6 mb-3" key={name}>
                  <Form.Label>{name}</Form.Label>
                  <Field
                    as={Form.Control}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    min={name === "Age" ? 18 : undefined}
                    max={name === "Age" ? 100 : undefined}
                  />
                  <div className="text-danger">
                    <ErrorMessage name={name} />
                  </div>
                </div>
              ))}

              <div className="col-md-6 mb-3">
                <Form.Label>Teaches</Form.Label>
                  <Field name="Language"
                    component={LanguageSelect}
                    options={learningLanguages}
                    placeholder="Select language" />
                <div className="text-danger"><ErrorMessage name="Language" /></div>
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Gender</Form.Label>
                <Field as="select" name="Gender" className="form-control">
                  <option value="" disabled hidden>
                    Select gender
                  </option>
                  {genderOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Field>
                <div className="text-danger">
                  <ErrorMessage name="Gender" />
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Timezone</Form.Label>
                <Select
                  inputId="timezone-select"
                  options={timezoneOptions}
                  value={timezoneOptions.find(opt => opt.label === values.Timezone) || null}
                  onChange={(option) => setFieldValue('Timezone', option ? option.label : '')}
                  placeholder="Select timezone"
                  isSearchable
                  menuPlacement="auto"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    menuList: base => ({ ...base, maxHeight: 200, overflowY: 'auto' }),
                    control: base => ({ ...base, minHeight: '44px' }),
                  }}
                />
                <div className="text-danger">
                  <ErrorMessage name="Timezone" />
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Experience Level (Years)</Form.Label>
                <Field as={Form.Control} name="ExperienceLevel" type="number" placeholder="Enter experience" min={0} max={50} />
                <div className="text-danger"><ErrorMessage name="ExperienceLevel" /></div>
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Phone Number</Form.Label>
                <div >
                  <div >
                    <CountryCodeSelect
                      value={values.whatsappNumber} // Full phone number with country code
                      onChange={(phone) => setFieldValue('whatsappNumber', phone)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12 mb-3">
                <Form.Label>About</Form.Label>
                <Field as="textarea" name="About" className="form-control" placeholder="Write a short description about the tutor" rows={4} />
                <div className="text-danger"><ErrorMessage name="About" /></div>
              </div>
            </Form>
          </FormikForm>
        </GenericModal>
      )}
    </Formik>
  );
};